import { useState, useEffect } from 'react';
import NaviBar from '../NaviBar/NaviBar';
import SearchBar from '../NaviBar/SearchBar';
import Cookies from 'js-cookie';
import noimg from '../../Icons/noimg.jpg';
import { Modal } from 'react-bootstrap';
import { currencyStyle } from '../../services/methods';
import { currencyOptions } from '../../staticData/options';
import addIcon from '../../Icons/add-quantity-icon.svg';
import decreIcon from '../../Icons/decrease-qtt.svg';
import 'animate.css';
import BottomCard from '../ShoppingCart/BottomCart';
import ProductCard from '../homeProduct/ProductCard';
import BrandCard2 from '../homeProduct/BrandCard2';
import { useTranslation } from 'react-i18next';
import QRModal from '../items/QRModal';
import Draggable from 'react-draggable';
import buy_now from '../../Icons/buy_now.png';

function CategoryPage(props) {
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  const { t } = useTranslation();
  const {
    cart,
    add,
    decreStock,
    changeProdPrice,
    alterquantity,
    itemCounter,
    langs,
    remove,
    setShowCart,
    showCart,
    brandOrCate,
    catename,
    id,
    setlangs,
    stat,
    setStat,
  } = props;

  const machine = JSON.parse(localStorage.getItem('machine'));
  const qrcode = machine?.themeColor?.allBrand;

  const [drag, setDrag] = useState(false);
  const [showQR, setShowQR] = useState(false);

  const QRpage = () => {
    setShowQR(true);
  };

  useEffect(() => {
    return () => {
      setDrag(true);
    };
  }, []);

  const currentCate = JSON.parse(localStorage.getItem('currentCate'))
    ? JSON.parse(localStorage.getItem('currentCate'))
    : null;

  let Fname = 'Products';
  if (currentCate?.name) {
    Fname =
      currentCate.name[langs] && currentCate.name[langs] !== ''
        ? currentCate.name[langs]
        : currentCate.name?.en;
  }

  useEffect(() => {
    const mycoockie = Cookies.get('i18next');
    if (mycoockie === 'fr') {
      setMainL('fr-CA');
    } else if (mycoockie === 'es') {
      setMainL('es-US');
    }
  }, []);

  const [mainL, setMainL] = useState('en-US');
  const [showp, setShowp] = useState(false);

  let imageUrl = '';

  const allProductImage = machine.themeColor?.allProduct
    ? isLocal
      ? `${process.env.REACT_APP_LOCAL_API}/pictures/machines/${machine.themeColor?.allProduct}`
      : `${process.env.REACT_APP_SERVER_API}/pictures/${machine.themeColor?.allProduct}/${machine.belongTo}`
    : noimg;

  // const allProductImage = machine.themeColor?.allProduct
  // ? `${process.env.REACT_APP_SERVER_API}/pictures/${machine.themeColor?.allProduct}/${machine.belongTo}`
  // : noimg;

  let symbol = machine?.currency?.symbol;
  symbol = symbol ? symbol : '$';
  let result = JSON.parse(localStorage.getItem('products'));

  let brands = JSON.parse(localStorage.getItem('brand'))
    ? JSON.parse(localStorage.getItem('brand'))
    : [];

  if (catename !== 'all' && catename !== 'allBrand') {
    if (brandOrCate === 'brand') {
      // imageUrl = `${process.env.REACT_APP_SERVER_API}/pictures/${currentCate.picture}/${currentCate.referTo}`;
      imageUrl = isLocal
        ? `${process.env.REACT_APP_LOCAL_API}/pictures/brand/${currentCate.picture}`
        : `${process.env.REACT_APP_SERVER_API}/pictures/${currentCate.picture}/${currentCate.referTo}`;
      result = result.filter((product) => product.brand?._id === id);
    } else if (brandOrCate === 'cate') {
      // imageUrl = `${process.env.REACT_APP_SERVER_API}/pictures/${currentCate.categoryPicture}/${currentCate.referTo}`;
      imageUrl = isLocal
        ? `${process.env.REACT_APP_LOCAL_API}/pictures/category/${currentCate.categoryPicture}`
        : `${process.env.REACT_APP_SERVER_API}/pictures/${currentCate.categoryPicture}/${currentCate.referTo}`;
      result = result.filter((product) => product.category.includes(id));
    }
  } else {
    imageUrl = allProductImage;
  }

  //
  useEffect(() => {
    if (catename === 'allBrand') {
      stat.all_brand = stat.all_brand += 1;
    } else if (catename === 'all') {
      stat.all_prod = stat.all_prod += 1;
    } else {
      if (brandOrCate === 'cate') {
        const index = stat?.cate.findIndex((item) => item._id === id);
        if (index >= 0) {
          stat.cate[index].detail = stat.cate[index].detail += 1;
        } else {
          stat.cate.push({
            _id: id,
            detail: 1,
            name: currentCate.name?.en,
          });
        }
      }
      if (brandOrCate === 'brand') {
        const index = stat?.brand.findIndex((item) => item._id === id);
        if (index >= 0) {
          stat.brand[index].detail = stat.brand[index].detail += 1;
        } else {
          stat.brand.push({
            _id: id,
            detail: 1,
            name: currentCate.name?.en,
          });
        }
      }
    }
    console.log(stat);
    setStat(stat);
  }, []);

  if (catename === 'allBrand') {
    brands = brands?.sort((a, b) => {
      const nameA = a.name[langs] ? a.name[langs].toUpperCase() : a.name['en'].toUpperCase();
      const nameB = b.name[langs] ? b.name[langs].toUpperCase() : b.name['en'].toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      return 0;
    });
  } else {
    result = result?.sort((a, b) => {
      const nameA = a.name[langs] ? a.name[langs].toUpperCase() : a.name['en'].toUpperCase();
      const nameB = b.name[langs] ? b.name[langs].toUpperCase() : b.name['en'].toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      return 0;
    });
  }

  const products =
    catename === 'allBrand'
      ? brands.map((brand) => {
          // const url = `${process.env.REACT_APP_SERVER_API}/pictures/${brand.picture}/${brand.referTo}`;
          const url = isLocal
            ? `${process.env.REACT_APP_LOCAL_API}/pictures/brand/${brand.picture}`
            : `${process.env.REACT_APP_SERVER_API}/pictures/${brand.picture}/${brand.referTo}`;
          return <BrandCard2 key={brand._id} langs={langs} prod={brand} image={url} />;
        })
      : result.map((prod) => {
          // const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.productPictures[0]}/${prod.referTo}`;
          const url = isLocal
            ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${prod.productPictures[0]}`
            : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.productPictures[0]}/${prod.referTo}`;
          return (
            <ProductCard
              twoLine={true}
              langs={props.langs}
              mainL={mainL}
              symbol={symbol}
              setShowp={setShowp}
              cart={props.cart}
              alterquantity={props.alterquantity}
              add={props.add}
              key={prod._id}
              remove={remove}
              decreStock={props.decreStock}
              price={prod.price}
              id={prod._id}
              prod={prod}
              products={props.products}
              i={prod.idx}
              name={prod.name}
              buyX={prod.buyX}
              percentage={prod.percentage}
              discountedPrice={prod.discountedPrice}
              amount={prod.discount}
              image={url}
            />
          );
        });

  return (
    <div className="main-container">
      {showQR && (
        <QRModal
          show={showQR}
          setShow={setShowQR}
          code={qrcode}
          machine={machine}
          isLocal={isLocal}
        />
      )}
      {qrcode && (
        <Draggable
          axis="both"
          handle=".handle"
          defaultPosition={{ x: 0, y: 780 }}
          position={null}
          grid={[25, 25]}
          scale={1}
          onClick={QRpage}
          onDrag={() => {
            setDrag(true);
          }}
          onStop={() => {
            const stage = drag;
            setDrag(false);
            if (!stage) {
              QRpage();
            }
          }}
        >
          {!showQR ? (
            <div className="d-flex handle floating_button">
              <img className="" src={buy_now} alt=""></img>
            </div>
          ) : (
            <div></div>
          )}
        </Draggable>
      )}
      <div className="Navi"></div>
      <NaviBar setShowCart={setShowCart} setlangs={setlangs} cart={cart} />
      <SearchBar langs={langs} />
      <img className="cate-banner-img" src={imageUrl} alt=""></img>
      <div className="cate-page-container">
        <div className="homeProductText" style={{ marginTop: 0 }}>
          {catename === 'all'
            ? t(`All Products`)
            : catename === 'allBrand'
            ? t('All Brands')
            : Fname}
        </div>
        <div className="cate-products-container">{products}</div>
      </div>
      <BottomCard
        isLocal={isLocal}
        cart={cart}
        setShowCart={setShowCart}
        showCart={showCart}
        prods={result}
        langs={langs}
        add={add}
        decreStock={decreStock}
        alterquantity={alterquantity}
        remove={remove}
      />
      {showCart && <div></div>}
    </div>
  );
}
export default CategoryPage;
